/**
 * @file ロゴだけのヘッダ
 */

import { css } from '~/styled-system/css'
import { flex } from '~/styled-system/patterns'
import { HeaderLogo } from './HeaderLogo'
import { HeaderWrapper } from './HeaderWrapper'

export function PlainHeader() {
  return (
    <HeaderWrapper>
      <header
        className={flex({
          justify: 'center',
          bgColor: 'white',
          borderBottom: 'medium',
          _sd: { py: '2', minHeight: '[42px]' },
        })}
      >
        <div className={css({ _pc: flex.raw({ width: 'content.base', py: '3' }) })}>
          <HeaderLogo />
        </div>
      </header>
    </HeaderWrapper>
  )
}
